import { track } from '@tldraw/tldraw'
import { FontWeightProps } from './Types'
import { useUpdateStyle } from 'components/VisualStudioPlayground/VisualEditor/hooks/useUpdateStyle'
import { FontWeightStyle } from 'components/VisualStudioPlayground/VisualEditor/StyleProps'
import { FONT_WEIGHTS } from 'components/VisualStudioPlayground/Shapes/TextBoxShape/constants'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import Styles from '../FontStylesPanel.module.scss'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'

const FontWeight = track(
  observer(({ editor, style, fontFamilyStyle }: FontWeightProps) => {
    const updateStyle = useUpdateStyle(editor)
    const { fonts } = useRootStore()

    const font = fontFamilyStyle.type === 'shared' ? fonts.get(fontFamilyStyle.value) : undefined
    const availableWeights = font?.weights || [400]

    return (
      <div className={Styles.fontSection}>
        <Text variant="smallList">Font Weight</Text>
        <div className={Styles.buttonsGrid}>
          {availableWeights.map((weight) => {
            const textValue = FONT_WEIGHTS[weight]
            return (
              <Button
                forceActive={style.type !== 'mixed' && style.value === weight}
                key={weight}
                variant="tertiary"
                size="md"
                onPress={() => updateStyle(FontWeightStyle, weight)}
              >
                {textValue}
              </Button>
            )
          })}
        </div>
      </div>
    )
  }),
)

export { FontWeight }
